import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Box, Grid, Typography, Button, Snackbar, Alert } from '@mui/material'
import { Add } from '@mui/icons-material'
import { EditorState } from 'draft-js'
import { dealFormValidation } from '@utils/dataHelper'
import { useWallet } from '@utils/walletHelper'
import { 
  setDealName,
  setDealDesc,
  setDealWebsiteUrl,
  setDealCrypto,
  setLeadInvestor,
  setPresailAmount,
  setMinsaleAmount,
  setMaxsaleAmount,
  setStartBonus,
  setEndBonus,
  setDealLogo,
  setOfferPeriod,
  setMinStakeAmount,
  setMaxStakeAmount
} from '@modules/redux/actions'
import DealItem from '@components/DealItem'
import { getDealList, addDeal } from '@hooks/contract'
import AddDealDialog from '@components/Dialogs/AddDealDialog'
import ClockLoader from '@components/Loaders/Clock'
import '../NotFound/NotFound.scss'
import Layout from "../Layout"

const MyDealList = ({ 
  setDealName,
  setDealDesc,
  setDealWebsiteUrl,
  setDealCrypto,
  setLeadInvestor,
  setPresailAmount,
  setMinsaleAmount,
  setMaxsaleAmount,
  setStartBonus,
  setEndBonus,
  setDealLogo,
  setOfferPeriod,
  setMinStakeAmount,
  setMaxStakeAmount,
  dealData 
}) => {
  const { connected, connecting, walletAddress } = useWallet()
  const [dealList, setDealList] = useState(null)
  const [loader, setLoader] = useState(false)
  const [textFieldError, setTextFieldError] = useState({})
  const [showDealDialog, setShowDealDialog] = useState(false)

  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: undefined,
  })

  useEffect(() => {
    const initialHandler = () => {
      setDealName('')
      setDealDesc(EditorState.createEmpty())
      setDealWebsiteUrl('')
      setDealCrypto('')
      setLeadInvestor('')
      setPresailAmount(0)
      setMinsaleAmount(0)
      setMaxsaleAmount(0)
      setStartBonus(0)
      setEndBonus(0)
      setDealLogo('')
      setOfferPeriod(0)
      setMinStakeAmount(0)
      setMaxStakeAmount(0)
    }

    initialHandler()
  }, [setDealName, setDealDesc, setDealWebsiteUrl, setDealCrypto, setLeadInvestor, setPresailAmount, setMinsaleAmount, setMaxsaleAmount, setStartBonus, setEndBonus, setDealLogo, setOfferPeriod, setMinStakeAmount, setMaxStakeAmount])

  useEffect(() => {
    let isMounted = true
    const fetchDataHandler = async () => {
      if(!connecting) {
        setLoader(true)
        try {
          const result = await getDealList(walletAddress, "my_deals")
          if(isMounted) {
            setDealList(result)
          }
        } catch (error) {
          console.log(error)        
        }
        setLoader(false)
      }
    }

    fetchDataHandler()

    return () => { isMounted = false }
  }, [connecting, walletAddress, setDealList, setLoader])

  // useEffect(() => {
  //   let _interval = setInterval(() => {
  //     fetchData()
  //   }, 5000)
    
  //   return () => {
  //     clearInterval(_interval)
  //   }
  // })

  const fetchData = async () => {
    const result = await getDealList(walletAddress, "my_deals")
    if(result) {
      setDealList(result)
      return true
    } else {
      return false
    }
  }

  const addDealHandler = async () => {
    const validCheck = dealFormValidation(dealData, setTextFieldError, "new")
    if (!validCheck) {
      setShowDealDialog(false)
      setLoader(true)
      const result = await addDeal(connected, walletAddress, dealData)
      if (result) {
        setDealList(result)
        displayNotify('success', 'Your transaction has succeeded.')
      } else {
        displayNotify('error', 'Your transaction has failed. Please try again!')
      }
      setLoader(false)
    }
  }

  const closeModal = () => {
    setShowDealDialog(false)
  }

  const displayNotify = (type, content) => {
    setAlert({
      open: true,
      message: content,
      severity: type,
    })
  }

  return (
    <Layout>
      {connected ? (
        <>
          <Box
            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            <Typography
              variant="h2"
              className="font-40 font-bold"
              sx={{ mt: 3, mb: 5 }}
            >
              My Sponsored deals
            </Typography>
            <Button
              className="btn-info"
              startIcon={<Add />}
              onClick={() => setShowDealDialog(true)}
            >
              Create Deal
            </Button>
          </Box>
          {dealList !== null && dealList.length > 0 ? (
            <Grid container spacing={2}>
              {
                dealList.slice(0).reverse().map((data, index) => {
                  return (
                    <Grid
                      key={index}
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      lg={4}
                      xl={3}
                    >
                      <Link
                        to={`/deal/${data.id}`}
                        className="no_underline text-white"
                      >
                        <DealItem data={data} />
                      </Link>
                    </Grid>
                  )
                })
              }
            </Grid>
          )
            : !loader && (
              <Box
                sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", paddingTop: "15vh" }}
              >
                <Box>You are not offering any deals</Box>
              </Box>
            )
          }
        </>
      ) : (
        <Box className="page-404">
          <Typography variant="h1">
            404
          </Typography>
          <Typography variant="h6">
            Page Not Found
          </Typography>
          <Typography sx={{ pb: 2 }}>
            Please connect your wallet to view the contents of this page.
          </Typography>
          <Link to="/" className="no_underline text-white">
            <Button className="btn-info">
              Go to Home
            </Button>
          </Link>
        </Box>
      )
      }
      {showDealDialog &&
        <AddDealDialog
          open={showDealDialog}
          closeModal={closeModal}
          textFieldError={textFieldError}
          eventHandler={addDealHandler}
          dealInfo={null}
          isNew={true}
        />
      }
      {loader && <ClockLoader />}
      <Snackbar
        open={alert.open}
        autoHideDuration={6000}
        onClose={() => setAlert({ ...alert, open: false })}
      >
        <Alert
          onClose={() => setAlert({ ...alert, open: false })}
          severity={alert.severity}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </Layout>
  )
}

const mapStateToProps = ({ deal }) => ({
  dealData: deal
});

const mapToDispatchProps = (dispatch) => ({
  setDealName: (name) => dispatch(setDealName(name)),
  setDealDesc: (desc) => dispatch(setDealDesc(desc)),
  setDealWebsiteUrl: (url) => dispatch(setDealWebsiteUrl(url)),
  setLeadInvestor: (addr) => dispatch(setLeadInvestor(addr)),
  setDealCrypto: (crypto) => dispatch(setDealCrypto(crypto)),
  setPresailAmount: (amount) => dispatch(setPresailAmount(amount)),
  setMinsaleAmount: (amount) => dispatch(setMinsaleAmount(amount)),
  setMaxsaleAmount: (amount) => dispatch(setMaxsaleAmount(amount)),
  setMinStakeAmount: (amount) => dispatch(setMinStakeAmount(amount)),
  setMaxStakeAmount: (amount) => dispatch(setMaxStakeAmount(amount)),
  setStartBonus: (bonus) => dispatch(setStartBonus(bonus)),
  setEndBonus: (bonus) => dispatch(setEndBonus(bonus)),
  setDealLogo: (file) => dispatch(setDealLogo(file)),
  setOfferPeriod: (period) => dispatch(setOfferPeriod(period)),
});

export default connect(mapStateToProps, mapToDispatchProps)(MyDealList);